module.exports = __webpack_public_path__ + "static/outside-dispenser-f62437fb4a08e7bb7032d6986169c38a.jpg";